<template>
  <div >
    <div v-if="!passwordUpdateEmailSent">
      <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
      <p v-if="expiredPwd">{{ $t('account.password-update.expired-password') }}</p>
      <p>{{ $t('account.password-update.reset-password') }}</p>
      <base-input v-model="$v.form.email.$model" placeholder="Email" :state="validateState('email')"></base-input>
      <b-form-invalid-feedback :state="validateState('email')">{{ $t('account.password-update.email-required') }}</b-form-invalid-feedback>
      <base-button class="mt-3" @click="sendPasswordResetEmail">{{ $t('account.password-update.send-password-email') }}</base-button>
    </div>
    <div v-else>
      <p>{{ $t('account.password-update.email-sent', { email: form.email }) }}</p>
      <p>{{ $t('account.password-update.check-email')}}</p>
      <p>{{ $t('account.password-update.check-spam')}}</p>
      <p>{{ $t('account.password-update.check-register-email')}}</p>
    </div>
  </div>
</template>

<script>
import AccountRepository from '@/repositories/AccountRepository'
import { BAlert, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationsMixin } from '@/mixins/validations.mixin'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    BAlert,
    BFormInvalidFeedback
  },
  mixins: [validationsMixin],
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  data () {
    return {
      passwordUpdateEmailSent: false,
      form: {
        email: null
      },
      expiredPwd: false,
      error: null
    }
  },
  methods: {
    sendPasswordResetEmail () {
      if (this.formIsValid()) {
				AccountRepository.sendPasswordUpdateEmail(this.$v.form.email.$model).then((response) => {
					const responseData = response.data
					const hasExceptionType = (response.response && response.response.status !== 200 && response.response.data.ExceptionType)
					const hasErrorMessage = (response.data && response.data.error && response.data.error.errorMessage)
					if ((hasExceptionType || hasErrorMessage) && (!responseData || !responseData.requiredAction)) {
						const msgKey = hasExceptionType ? response.response.data.ExceptionType : response.data.error.errorMessage
						const transKey = `login.errors.${msgKey}`
						this.error = (this.$te(transKey) ? this.$t(transKey) : this.$t('account.password-update.error-found'))
					} else if (responseData) {
						this.passwordUpdateEmailSent = true
					} else {
						this.error = this.$t('account.password-update.error-found')
					}
				})
			}
		}
  },
  mounted () {
    this.expiredPwd = !!this.$route.query.expired
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/account/PasswordUpdateEmail.vue